import { NgModule, NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppMaterialModule } from "@root/app-material.module";
import { NgxPaginationModule } from 'ngx-pagination';
import { AppCommonModule } from "@root/modules/common/common.module";
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from  '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicStorageModule ,Storage} from '@ionic/storage-angular';
import { IonBottomDrawerModule } from 'ion-bottom-drawer';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Device } from '@ionic-native/device/ngx';
import { CoreService } from '../core/core.service';
import { CORE_PROPS } from '../core/core.properties';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { DocumentViewer } from '@ionic-native/document-viewer/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { SocialSharing } from "@ionic-native/social-sharing/ngx";
import { Diagnostic } from '@ionic-native/diagnostic/ngx';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  entryComponents: [],
  imports: [BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppMaterialModule,
    NgxPaginationModule,
    IonBottomDrawerModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
    }),
    AppCommonModule],
  providers: [
    CORE_PROPS,
    FileOpener,
    File,
    DocumentViewer,
    CoreService,
    Device,
    StatusBar,
    SplashScreen,
    InAppBrowser,
    Storage,
    AppVersion,
    SocialSharing,
    Diagnostic
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class AppModule { }
